/** @module Merchandising/VersionsToSelectController */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/action/AggregateController",
	"./_VersionsMixin"
], function(declare,_,AggregateController,_VersionsMixin) {

	return declare([AggregateController,_VersionsMixin], {

	});
});
